import "react-toastify/dist/ReactToastify.css";
import "./styles.scss";

import { useEffect } from "react";
import { Outlet } from "react-router-dom";

import { Sidebar, MenuMobile } from "./components";
import NotifyContainer from "components/NotifyContainer";

import useResponsive from "libs/helpers/useResponsive";
import ScrollToTop from "libs/helpers/ScrollToTop";

const DashboardLayout = () => {
  const { max } = useResponsive();

  useEffect(() => {
    const preventFileNavigation = (event) => {
      const { dataTransfer, target } = event;
      const hasFiles =
        Array.from(dataTransfer?.types ?? []).includes("Files") ||
        dataTransfer?.files?.length > 0;
      const isFileInput =
        target instanceof HTMLInputElement &&
        target.type === "file" &&
        !target.disabled;

      if (hasFiles && !isFileInput) event.preventDefault();
    };

    window.addEventListener("dragover", preventFileNavigation);
    window.addEventListener("drop", preventFileNavigation);

    return () => {
      window.removeEventListener("dragover", preventFileNavigation);
      window.removeEventListener("drop", preventFileNavigation);
    };
  }, []);

  return (
    <>
      <div className="dashboard-layout">
        {!max.sm && <Sidebar />}
        <Outlet />
        {max.sm && <MenuMobile />}
      </div>

      <NotifyContainer />
      <ScrollToTop />
    </>
  );
};

export default DashboardLayout;
